"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var Typography_1 = require("../../Typography");
var StyledButton = styled_components_1.default(antd_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  &[ant-click-animating-without-extra-node]:after {\n    border: 0 none;\n    opacity: 0;\n    animation: none 0 ease 0 1 normal;\n  }\n"], ["\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  color: ", ";\n\n  &:hover {\n    color: ",
    ";\n  }\n\n  &[ant-click-animating-without-extra-node]:after {\n    border: 0 none;\n    opacity: 0;\n    animation: none 0 ease 0 1 normal;\n  }\n"])), function (_a) {
    var $active = _a.$active, $color = _a.$color;
    return $color || ($active ? "#1890FF" : "black");
}, function (_a) {
    var $active = _a.$active, $color = _a.$color;
    return $color || ($active ? "#1890FF" : "#8C8C8C");
});
var ControlBarButton = function (_a) {
    var tooltip = _a.tooltip, active = _a.active, color = _a.color, rest = __rest(_a, ["tooltip", "active", "color"]);
    return (react_1.default.createElement(react_1.default.Fragment, null, tooltip ? (react_1.default.createElement(antd_1.Tooltip, { mouseEnterDelay: 0.5, title: react_1.default.createElement(Typography_1.Typography, null, tooltip), color: "white" },
        react_1.default.createElement(StyledButton, __assign({ size: "small", "$color": color, "$active": active }, rest)))) : (react_1.default.createElement(StyledButton, __assign({ size: "small", "$color": color, "$active": active }, rest)))));
};
exports.default = ControlBarButton;
var templateObject_1;
